import React, { useState, useEffect } from "react";
import { ArchiveTopBox, ImportantNews2, Footer2 } from "../../components";
import { ReactComponent as Right } from "../../assets/icon/right.svg";
import { ReactComponent as Left } from "../../assets/icon/left.svg";
import { axiosReq } from "../../commons/axiosReq";
import { apiAsset } from "../../commons/inFormTypes";
import { useLocation, useSearchParams } from "react-router-dom";
import moment from 'jalali-moment'

export const truncate = (str, len) => {
    if (str?.length > len && str?.length > 0) {
        let new_str = str + " ";
        new_str = str?.substr(0, len);
        new_str = str?.substr(0, new_str.lastIndexOf(" "));
        new_str = new_str.length > 0 ? new_str : str?.substr(0, len);
        return new_str + "...";
    }
    return str;
};
const ArchiveAllNews = () => {

    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    const [data, setData] = useState();
    const [search, setSearch] = useState("");
    const [reCheck, setRecheck] = useState(false);
    const [count, setCount] = useState();
    const [page, setPage] = useState(1);
    const [row, setRow] = useState(10);
    const [cat, setCat] = useState(0);
    const [cats, setCats] = useState();
    const [start, setStart] = useState("");
    const [end, setEnd] = useState("");
    const [prominent, setProminent] = useState(false);
    const [last, setLast] = useState(false);
    const [most, setMost] = useState(false);
    const [main, setMain] = useState(false);
    const [admins, setAdmins] = useState();
    const [admin, setAdmin] = useState();
    const GetData = async () => {
        console.log(searchParams)
        console.log(location)
        var ad = admin ? admin?.split("T")[1] == "Admin" ? admin?.split("T")[0] : 0 : 0
        var ath = admin ? admin?.split("T")[1] == "Author" ? admin?.split("T")[0] : 0 : 0
        if (location?.pathname) {
            // setCat(location?.pathname)
            const writersData = await axiosReq("Admins/SearchArticle?page=" + page + "&&pageSize=" + row + "&&search=" + location.pathname.split("/")[2] + "&&category=" + cat + "&&startDate=" + start +
                "&&endDate=" + end + "&&authorId=" + ath
                + "&&adminId=" + ad
                + "&&isProminent=" + prominent + "&&isLast=" + last + "&&isMostViewed=" + most + "&&mainPage=" + main, "get");
            console.log(writersData)
            setData(writersData?.data)
            setCount(writersData?.count)
        }
    }
    useEffect(() => {

        GetData();
    }, [reCheck, search, page, row,]);

    return (
        <>
            {/* {
                data ?
                    <ArchiveTopBox imgPath={apiAsset + data[0]?.mainPicture}
                        title={data[0]?.articleTittle}
                        text={data[0]?.newsBox}
                        link={"/news/" + data[0]?.articleCategories?.category?.categorySlug + "/" + data[0]?.slug}
                        />
                    : null
            } */}


            <div className="flex justify-center pr-[0.5%]">
                <div className=" flex justify-start items-center w-[90%] mt-[40px] md:mr-2">
                    <div
                        className="w-[38px] h-[11px]  bg-nextColor rounded-[50px] shadow-yellowShadow mt-[10px]"></div>
                    <div
                        className="w-[11px] h-[11px] mr-[5px] bg-nextColor rounded-[50px] shadow-yellowShadow mt-[10px]"></div>
                    <p className="text-2xl text-mainColor2 font-IRANYekanExtra mx-[15px]">آرشیو اخبار</p>
                </div>
            </div>
            <div className="w-[90%] mx-auto flex flex-wrap  opacity-100  md:mx-[10px] md:flex-wrap mt-[50px] md:w-full ">
                {
                    data?.map((item, index) => {
                        return (
                            <div className="w-[24%] mb-[30px] mx-[0.5%] md:w-[48%] md:mx-[1%]">
                                <ImportantNews2
                                    imgPath={item?.mainPicture}
                                    title={item?.articleTittle}
                                    text={item ?
                                        truncate(item?.newsBox, 120) :
                                        null}
                                    date={moment(item?.datePublished?.split("T")[0].replace("-", "/"), 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')}
                                    time={item?.datePublished?.split("T")[1].substr(0, 5)} 
                                    link={"/news/" + item?.articleCategories[0]?.category?.categoryName + "/" + item?.slug}
                                />
                            </div>

                        )
                    })
                }
            </div>

            {/* <div className="w-[90%] mx-auto flex justify-center  opacity-100  md:mx-[10px] md:flex-wrap mt-[30px] md:w-full">
                    <div className="w-[24%] mx-[0.5%] md:w-[48%] md:mx-[1%]"><ImportantNews2 imgPath={"news2.jpg"} title={"جلسه علنی رئیس جمهور"} date={"سه شنبه 17 مهر"} time={"15:13"} text={"اجتماع بزرگ مردمی «دفاع از جبهه مقاومت و اعلام آمادگی مبارزه همه‌جانبه با صهیونیسم» بعد از ظهر..."}/></div>
                    <div className="w-[24%] mx-[0.5%] md:w-[48%] md:mx-[1%]"><ImportantNews2 imgPath={"news3.jpg"} title={"برگزاری اجتماع مردمی در میدان فلسطین"} date={"سه شنبه 17 مهر"} time={"15:13"} text={"اجتماع بزرگ مردمی «دفاع از جبهه مقاومت و اعلام آمادگی مبارزه همه‌جانبه با صهیونیسم» بعد از ظهر..."}/></div>
                    <div className="w-[24%] mx-[0.5%] md:w-[48%] md:mx-[1%]"><ImportantNews2 imgPath={"news1.jpg"} title={"جلسه علنی رئیس جمهور"} date={"سه شنبه 17 مهر"} time={"15:13"} text={"اجتماع بزرگ مردمی «دفاع از جبهه مقاومت و اعلام آمادگی مبارزه همه‌جانبه با صهیونیسم» بعد از ظهر..."}/></div>
                    <div className="w-[24%] mx-[0.5%] md:w-[48%] md:mx-[1%]"><ImportantNews2 imgPath={"news3.jpg"} title={"برگزاری اجتماع مردمی در میدان فلسطین"} date={"سه شنبه 17 مهر"} time={"15:13"} text={"اجتماع بزرگ مردمی «دفاع از جبهه مقاومت و اعلام آمادگی مبارزه همه‌جانبه با صهیونیسم» بعد از ظهر..."}/></div>
            
            </div> */}
            <div className="w-[90%] mx-auto   opacity-100  md:mx-[10px] md:flex-wrap mt-[30px] md:w-full py-3 px-3">
                <div className="flex items-center justify-between">
                    <div className="flex items-center">
                        {/* <p className="text-sm text-right px-4">
                            تعداد ردیف در هر صفحه :
                        </p> */}
                        <div className="flex flex-col w-[80px] ml-20">
                            <div class=" ">

                                {/* <select
                                    name="rowNumber"
                                    id="rowNumber"
                                    onChange={(e) => { setRow(e.target.value); setPage(1) }}
                                    className="   text-right  bg-white border border-gray-300 text-gray-900 text-sm rounded-md  focus:ring-mainColor focus:border-mainColor block w-full px-2 py-1">
                                    <option value="5" className=" ">۵ </option>
                                    <option value="10" selected className=" ">۱۰</option>
                                    <option value="25" className=" ">۲۵</option>


                                </select> */}
                                {/* <input
                                          type="text"
                                          id="input-group-1"
                                          disabled="true"
                                          class="pr-9   text-right right-6 bg-white border border-gray-300 text-gray-900 text-sm rounded-md  focus:ring-mainColor focus:border-mainColor block w-full pl-10 p-2.5  "
                                          placeholder="آرمان"/> */}
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center">

                        <p className="text-sm text-right pr-4 mx-2">
                            {((page - 1) * row) + 1}-{count < row * page ? count : row * page} از {count}
                        </p>
                        <div className="flex mr-2">
                            <button onClick={() => setPage(page + 1)} disabled={count < row * page ? true : false} className="mx-2">
                                <Right />
                            </button>
                            <button onClick={() => setPage(page - 1)} disabled={page == 1 ? true : false} className="mx-2">
                                <Left />
                            </button>
                        </div>
                    </div>
                </div>

            </div>

        </>
    )
}

export default ArchiveAllNews;